export default __webpack_public_path__ + "static/media/Rojevas-Blue.049759a6.svg";